import React from "react";
import ScrollReveal from "./ScrollReveal";
import { ShoppingCart, QrCode, Ticket, Swords } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

/** Título/descrição: howto.step<N>.title / .desc */
const STEPS = [
    { n: "01", key: "howto.step1", Icon: ShoppingCart },
    { n: "02", key: "howto.step2", Icon: QrCode },
    { n: "03", key: "howto.step3", Icon: Ticket },
    { n: "04", key: "howto.step4", Icon: Swords },
];

export default function HowToBuy() {
    const { t } = useI18n();
    return (
        <section
            id="loja"
            data-testid="how-to-buy-section"
            className="relative py-24 md:py-32 px-6 md:px-8"
        >
            <div className="max-w-6xl mx-auto">
                <ScrollReveal>
                    <div className="text-center mb-16 md:mb-20">
                        <div className="text-[11px] uppercase tracking-[0.4em] text-gold/80 mb-3">
                            {t("howto.eyebrow")}
                        </div>
                        <h2 className="text-3xl md:text-5xl font-bold text-zrs-offwhite">
                            {t("howto.title")}
                        </h2>
                    </div>
                </ScrollReveal>

                <div className="relative grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6">
                    {/* Connector line on desktop */}
                    <div className="hidden md:block absolute top-10 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />

                    {STEPS.map((s, i) => {
                        const { Icon } = s;
                        return (
                            <ScrollReveal key={s.n} delay={i * 110}>
                                <div
                                    data-testid={`step-card-${i + 1}`}
                                    className="relative h-full rounded-2xl p-5 md:p-6 border border-white/10 gold-border-hover"
                                    style={{
                                        background:
                                            "linear-gradient(180deg, rgba(26,15,10,0.9), rgba(10,7,6,0.85))",
                                    }}
                                >
                                    <div className="flex items-center justify-between mb-5">
                                        <div
                                            className="text-3xl md:text-4xl font-bold text-gold/90 leading-none"
                                            style={{ fontVariantNumeric: "tabular-nums" }}
                                        >
                                            {s.n}
                                        </div>
                                        <div
                                            className="w-10 h-10 rounded-lg flex items-center justify-center border"
                                            style={{
                                                background: "rgba(255,184,0,0.08)",
                                                borderColor: "rgba(255,184,0,0.2)",
                                            }}
                                        >
                                            <Icon size={18} className="text-gold" />
                                        </div>
                                    </div>
                                    <div className="text-[15px] font-bold text-zrs-offwhite mb-1">
                                        {t(`${s.key}.title`)}
                                    </div>
                                    <p className="text-[13px] text-zrs-offwhite/60 leading-relaxed">
                                        {t(`${s.key}.desc`)}
                                    </p>
                                </div>
                            </ScrollReveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
